import { PropsWithChildren } from 'react';

import { screen } from './WizardScreen.css';

type WizardScreenLayoutProps = PropsWithChildren<{
    open?: boolean;
}>;

export const WizardScreenLayout = ({ open = true, children }: WizardScreenLayoutProps) => {
    if (!open) return null;

    return <div className={screen}>{children}</div>;
};

WizardScreenLayout.displayName = 'WizardScreen.Layout';
